import React from 'react'
import { FormattedMessage } from 'react-intl';
import Sample from '../../sample'

import ButtonAsync from '../../button/button-async'
import Button from '../../button/button'
import Page from '../../page/page'
import List from '../../list/list'
import Label from '../../label'
import Text from '../../form/form-text'

import SidePanel from '../sidePanel/sidePanel'
import SidePanelContainer from '../sidePanel/sidePanel-transition'
import Types from '../sidePanel/sidePanel-types'
import {openSidePanelWithSelection, openSidePanelPage} from '../sidePanel/sidePanel-action'
import {open} from './index-actions'

//FIXME: create tools class ???
const onSuccess = () => new Promise((resolve, reject) => setTimeout(() => resolve(''), 2000))

import './index.styl'
class SidePanelSample extends Sample {
    static CONTAINER_ID = 'SidePanelSample';

    pathI18n = 'sample.app.components.sidePanel.'
    state = {}

    getTitle() {
        return this.pathI18n + 'page.title'
    }

    getBody() {
        const panelId = SidePanelSample.CONTAINER_ID
        let {pathI18n} = this

        let page = { type: FormattedMessage, attrs:{className: Types.slideRight, id: pathI18n + 'content'} };

        let page1 = { type: Page, attrs: {
            className: Types.slideTop,
            header: <Label>{pathI18n + 'title'}</Label>,
            body: <Label>{pathI18n + 'body'}</Label>,
            footer: <Label>{pathI18n + 'footer'}</Label>
        }};

        let page2 = { type: SidePanel, attrs: {
            className: Types.slideRight,
            openerType: ButtonAsync,
            containerId: panelId,
            openerAttrs: { onClick: e => onSuccess(e).then(v => Promise.resolve(page)), label:pathI18n + 'open.async' }
        }};

        let page4 = { type: Page, attrs: {
            className: Types.slideBottom,
            header: <Label>{pathI18n + 'title'}</Label>,
            body: <div>
                <SidePanel openerType={ButtonAsync}
                           openerAttrs={{onClick: e => onSuccess(e).then(v => Promise.resolve(page2)), label:pathI18n + 'open.async'}}
                           containerId="sidePanel-basic-page4-container"/>
                <SidePanelContainer id="sidePanel-basic-page4-container" />
            </div>,
            footer: <Label>{pathI18n + 'footer'}</Label>
        }};

        //should be a function with data argument !!!!
        let page3 = { type: Page, attrs: {
            header: <Label>{pathI18n + 'title'}</Label>,
            body: <div>
                <SidePanel openerType={ButtonAsync}
                           openerAttrs={{onClick: e => onSuccess(e).then(v => Promise.resolve(page)), label:pathI18n + 'open.async'}}
                           containerId="sidePanel-basic-page3-container"/>
                <SidePanel openerType={ButtonAsync}
                           openerAttrs={{onClick: e => onSuccess(e).then(v => Promise.resolve(page1)), label:pathI18n + 'open.async'}}
                           containerId="sidePanel-basic-page3-container"/>
                <SidePanel openerType={ButtonAsync}
                           openerAttrs={{onClick: e => onSuccess(e).then(v => Promise.resolve(page2)), label:pathI18n + 'open.async'}}
                           containerId="sidePanel-basic-page3-container"/>
                <SidePanel openerType={ButtonAsync}
                           openerAttrs={{onClick: e => onSuccess(e).then(v => Promise.resolve(page4)), label:pathI18n + 'open.async'}}
                           containerId="sidePanel-basic-page3-container"/>
                <SidePanelContainer id="sidePanel-basic-page3-container"/>
            </div>,
            footer: <button onClick={ console.log }><Label>app.cancel</Label></button>
        }};


        let panels = [
            <li><Button onClick={() => open(panelId)} label='app.open'/></li>,
            <li><Button onClick={() => open(panelId, page)} label='app.open'/></li>,
            <li><Button onClick={() => open(panelId, page1)} label='app.open'/></li>,
            <li><Button onClick={() => open(panelId, page2)} label='app.open'/></li>,
            <li><Button onClick={() => onSuccess().then(() => open(panelId, page1))} label='app.open'/></li>,
            <li><Button onClick={() => onSuccess().then(() => open(panelId, page2))} label='app.open'/></li>,

            <li><SidePanel openerType={ButtonAsync}
                openerAttrs={{className: Types.slideRight, onClick: e => onSuccess(e).then(v => Promise.resolve(page)), label:pathI18n + 'open.async'}}
                containerId={panelId}/></li>,
            <li><SidePanel openerType={ButtonAsync}
                openerAttrs={{className: Types.slideLeft, onClick: e => onSuccess(e).then(v => Promise.resolve(page1)), label:pathI18n + 'open.async1'}}
                containerId={panelId}/></li>,
            <li><SidePanel openerType={ButtonAsync}
                openerAttrs={{className: Types.slideBottom, onClick: e => onSuccess(e).then(v => Promise.resolve(page2)), label:pathI18n + 'open.async2'}}
                containerId={panelId}/></li>,
            <li><SidePanel openerType={ButtonAsync}
                openerAttrs={{className: Types.slideTop, onClick: e => onSuccess(e).then(v => Promise.resolve(page3)), label:pathI18n + 'open.async3'}}
                containerId={panelId}/></li>,
            <li><SidePanel openerType={ButtonAsync}
                openerAttrs={{onClick: e => onSuccess(e).then(v => Promise.resolve(page4)), label:pathI18n + 'open.async4'}}
                containerId={panelId}/></li>,
        ]
            // <li><SidePanel openerType={ButtonAsync}
            //         openerAttrs={{onClick: e => onSuccess(e).then(v => Promise.resolve(page2)), label:pathI18n + 'open.async6'}}
            //         containerId={panelId + '-bloc-2'}/>
            //     <SidePanelContainer id={panelId + '-bloc-2'} /></li>,
            // <li><SidePanel openerType={ButtonAsync}
            //        openerAttrs={{onClick: e => onSuccess(e).then(v => Promise.resolve(page)), label:pathI18n + 'open.async5'}}
            //        containerId={panelId + '-bloc-1'}/>
            //     <SidePanelContainer id={panelId + '-bloc-1'} /></li>,
            {/*<li><Button label={pathI18n + 'open.async5'} onClick={() => sidePanelFromTop(panelId, {type: Text, attrs:{ label: 'app.url', value: 'app.url'}}, '')} /></li>,*/}

            {/*<li><Button label={pathI18n + 'open.async6'} onClick={() => openSidePanelPage(panelId, Label, {children: pathI18n + 'children'}, 'app.label', 'sidePanel-label')} /></li>*/}


        return <div className="sample sample-sidePanel">
            <List collection={panels} />
            <SidePanelContainer id={panelId} />
        </div>
    }
}

export default SidePanelSample
